export default "__VITE_ASSET__Cdclwmlf__"